import { useMutation, useQueryClient } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { ace_api } from '@axo/shared/data-access/api';
import { bucketsKeys } from '../../cache-keys/bucketsKeys';

export function usePatchAssignee() {
  const api = useAPI();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ace_api.patchAssignee(api),
    onSettled(data) {
      if (data?.ID) {
        queryClient.invalidateQueries([bucketsKeys.assignee(data.ID)]);
      }
    },
  });
}
